const initialState = {
  isCompAllGroup: false,
  isVenueAvailable: true,
  activeMarketplaces: [],
  eventInfo: {},
  filteredListings: [],
};

function groupsStubhubState(state = initialState, action) {
  switch (action.type) {
    case 'SET_COMP_ALL_GROUPS':
      return { ...state, isCompAllGroup: action.payload };
    case 'SET_VENUE_AVAILABLE':
      return { ...state, isVenueAvailable: action.payload };
    case 'SET_ACTIVE_MARKETPLACES':
      return { ...state, activeMarketplaces: action.payload };
    case 'SET_EVENT':
      return { ...state, eventInfo: action.payload };
    case 'SET_MARKETPLACE_FILTERED_LISTINGS':
      return { ...state, filteredListings: action.payload };
    default:
      return state;
  }
}

export default groupsStubhubState;
